import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAddBrandingMutation } from 'src/api/branding/hooks';
import {
  validateEmpty,
  validateHexColor,
  validateHexColorRequired,
} from 'src/helpers/validators';
import { links } from 'src/router/routes';

export type FormData = {
  name: string;
  color_1: string;
  color_2: string;
  color_3: string;
  color_4: string;
  color_5: string;
  main_logo: File;
  secondary_logo: File;
  tertiary_logo: File;
};

export const initialValues: Partial<FormData> = {
  color_1: '',
  color_2: '',
  color_3: '',
  color_4: '',
  color_5: '',
  main_logo: undefined,
  name: '',
  secondary_logo: undefined,
  tertiary_logo: undefined,
};

export const validate = {
  color_1: validateHexColorRequired,
  color_2: validateHexColor,
  color_3: validateHexColor,
  color_4: validateHexColor,
  color_5: validateHexColor,
  main_logo: (value: File) => (!value ? 'Please select file' : undefined),
  name: (value: string) => validateEmpty(value, 'Please enter name'),
};

export const useAddBranding = () => {
  const { addBrandingMutation, isPending, isSuccess } =
    useAddBrandingMutation();
  const navigate = useNavigate();

  const onSubmit = async (data: FormData) => {
    await addBrandingMutation(data);
  };

  const onCancel = () => {
    navigate(links.brandings);
  };

  useEffect(() => {
    if (isSuccess) {
      navigate(links.brandings);
    }
  }, [isSuccess, navigate]);

  return {
    isPending,
    onSubmit,
    onCancel,
    initialValues,
    validate,
  };
};
